import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getTillDevicesForOrderAccess,
  updateTillOrderAccessSetting,
} from "@/api/online-ordering/settings/till-order-access";

export const fetchTillOrderAccessTills = createAsyncThunk(
  "tillOrderAccess/fetchTills",
  async (_, { rejectWithValue }) => {
    const response = await getTillDevicesForOrderAccess();
    if (response?.status === "success") {
      return response?.data?.tills || [];
    }

    return rejectWithValue(response?.message || "Failed to fetch tills");
  },
);

export const saveTillOrderAccess = createAsyncThunk(
  "tillOrderAccess/save",
  async ({ restaurantId, tillId }, { rejectWithValue }) => {
    const response = await updateTillOrderAccessSetting(restaurantId, {
      till_id: tillId,
    });

    if (response?.status === "success") {
      return response?.data || {};
    }

    return rejectWithValue(response?.message || "Failed to share till access");
  },
);

const initialState = {
  tills: [],
  selectedTillId: "",
  getLoading: false,
  saveLoading: false,
  success: null,
  error: null,
};

const tillOrderAccessSlice = createSlice({
  name: "tillOrderAccess",
  initialState,
  reducers: {
    setSelectedTillId: (state, action) => {
      state.selectedTillId = action.payload;
    },
    clearTillOrderAccessMessages: (state) => {
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTillOrderAccessTills.pending, (state) => {
        state.getLoading = true;
        state.error = null;
      })
      .addCase(fetchTillOrderAccessTills.fulfilled, (state, action) => {
        state.getLoading = false;
        const nextTills = action.payload || [];
        state.tills = nextTills;

        const hasSelected = nextTills.some(
          (till) => String(till.id) === String(state.selectedTillId),
        );

        if (!hasSelected) {
          state.selectedTillId = nextTills[0] ? String(nextTills[0].id) : "";
        }
      })
      .addCase(fetchTillOrderAccessTills.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload || "Failed to fetch till list";
      })
      .addCase(saveTillOrderAccess.pending, (state) => {
        state.saveLoading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(saveTillOrderAccess.fulfilled, (state) => {
        state.saveLoading = false;
        state.success = "Till order access saved successfully";
      })
      .addCase(saveTillOrderAccess.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.payload || "Failed to save till order access";
      });
  },
});

export const { setSelectedTillId, clearTillOrderAccessMessages } =
  tillOrderAccessSlice.actions;

export default tillOrderAccessSlice.reducer;
